import { render, staticRenderFns } from "./CustomPageCommon.vue?vue&type=template&id=17cc2f4c&scoped=true"
import script from "./CustomPageCommon.vue?vue&type=script&lang=js"
export * from "./CustomPageCommon.vue?vue&type=script&lang=js"
import style0 from "./CustomPageCommon.vue?vue&type=style&index=0&id=17cc2f4c&prod&lang=css"
import style1 from "./CustomPageCommon.vue?vue&type=style&index=1&id=17cc2f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cc2f4c",
  null
  
)

export default component.exports